var _defs, _path, _mask;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNoSmoking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_no_smoking_svg__a",
    d: "M0 32h32V0H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.052 19v-4h6.917L9.43 13H3.052a1 1 0 00-1 1v6a1 1 0 001 1h12.532l-1.539-2H4.052zM20.157 21h2.792v-2h-4.38l-3.076-4h7.456v-2h-8.995L5.493 2H2.97l8.46 11 1.54 2 3.077 4 1.538 2 6.923 9h2.523l-6.923-9z",
    fill: props.color
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon_no_smoking_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_no_smoking_svg__a"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    mask: "url(#icon_no_smoking_svg__b)",
    d: "M27.949 21h2v-8h-2zM24.949 21h2v-8h-2zM22.59 6.003c2.954 0 5.358 2.233 5.358 4.979h2c0-3.848-3.3-6.978-7.359-6.978-1.209 0-2.193-.898-2.193-2.001h-2c0 2.205 1.88 4 4.193 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.755 8.98c1.21 0 2.193.898 2.193 2h2c0-2.205-1.88-4-4.193-4-2.955 0-5.359-2.233-5.359-4.978h-2c0 3.848 3.301 6.978 7.36 6.978",
    fill: props.color,
    mask: "url(#icon_no_smoking_svg__b)"
  })));
}

export default SvgIconNoSmoking;